import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import shippingtable from "assets/images/shipping_table.svg";
import { LinkButton } from "components/buttons";

function ShippingGuarantee() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`Shipping
              <span className="jumbotron-subtitle-2">
                Guarantee-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Why wait for the export documents to arrive and lose precious time
              and money in the process? With alrajhi bank Malaysia’s Shipping
              Guarantee-<i>i</i>, you will be able to claim immediate possession
              of the goods you have ordered without making payment first or
              being presented with the necessary documents by your supplier.
              Avoid paying costly demurrage or storage charges. We provide the
              documents required to release your purchases so that you can
              expedite the delivery of your goods and minimise idle waiting
              time.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Open Account Trade</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <ul>
                <li>
                  Let us manage your "open trade" and "merchanting trade", and
                  ease your  reconciliation.
                </li>
                <li>
                  As our customer, we will manage your incoming outgoing
                  payments.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={shippingtable}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <LinkButton
                text={
                  <span>
                    SG-<em>i</em> Application Form
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/SG-i Application Form.pdf"
                  )
                }
              />
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/1680579344_Trade Finance Instruments - Fees and Charges.pdf"
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      {/* <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial deposit</div>
                <div className="column-subheader">
                  RM500 or USD5,000 or its equivalent
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Cheque book</div>
                <div className="column-subheader">
                  An alrajhi bank Malaysia cheque book{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Currency</div>
                <div className="column-subheader">
                  Available in MYR & selected foreign currencies
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Sharia standards</div>
                <div className="column-subheader">
                  In compliance with alrajhi bank Malaysia Shariah standard
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="section about container">
        <Row className="my-5 py-5">
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <div>
              {eligibility.points.eligibilitycurrentbiz.description.map(
                (benefit, index) => (
                  <div className="animated-list">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </div>
          </Col>
        </Row>
      </section> */}

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ShippingGuarantee;
